import React from 'react'
import { css } from '@emotion/css'

const formatCurrency = (value: number | string | undefined | null): string => {
  const num = Number(value)
  if (Number.isNaN(num)) return '0,00'

  return num
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

const MoneySmallDecimals = ({
  value,
  currency = '₺',
  location = 'right'
}: {
  value: number | string | undefined | null
  currency?: string
  location?: 'right' | 'left' | ''
}) => {
  const formatted = formatCurrency(value)
  const [intPart, fracPart] = String(formatted).split(',')

  return (
    <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
      {location === 'left' &&
        <span>{` ${currency}`}</span>
      }
      <span>{intPart}</span>
      {fracPart != null && (
        <>
          <span>,</span>
          <span style={{ fontSize: '0.78em', opacity: 0.85 }}>{fracPart}</span>
        </>
      )}
      {(location === 'right' || location === '') &&
        <span>{` ${currency}`}</span>
      }
    </div>
  )
}

export default MoneySmallDecimals
export { MoneySmallDecimals }
